import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// ScrollTriggerをGSAPに登録
gsap.registerPlugin(ScrollTrigger);

export function fadeIn() {
  setTimeout(function () {
    const sections = document.querySelectorAll(".js-section");

    // Odometerの設定
    const odometerElement = document.getElementById("odometer");
    const odometerElements = document.querySelectorAll(".js-odometer");

    if (odometerElement) {
      odometerElement.innerHTML = 0; // 初期値を0に設定

      if (odometerElements) {
        odometerElements.forEach((item) => {
          item.innerHTML = 0;
        });
      }
      // アニメーションを開始するタイミングを制御する関数
      function startOdometerAnimation() {
        // Odometerを使用して数値を変更
        odometerElement.innerHTML = 319; // 例: 1000までカウントアップ
      }

      gsap.set(".bar", { transformOrigin: "bottom", scaleY: 0 }); // スケールの起点を下端に設定
      function graphAni() {
        const tl = gsap.timeline({
          defaults: { duration: 0.6, ease: "power2.out" },
        });

        setTimeout(function () {
          tl.fromTo(
            ".bar",
            { scaleY: 0, transformOrigin: "bottom" }, // 開始時の設定
            //{ scaleY: 1, stagger: 0.2 } // stagger: で連続するアニメーション
            { scaleY: 1 } // 終了時の設定と遅延
          );
        }, 500);
      }

      sections.forEach((section) => {
        const fadeInItems = section.querySelectorAll(".js-fade-in");

        if (fadeInItems.length > 0) {
          fadeInItems.forEach((fadeInItem, index) => {
            gsap.set(fadeInItem, { opacity: 0, visibility: "hidden", y: 100 }); // 初期状態を設定
            ScrollTrigger.create({
              trigger: section,
              start: "top 70%",
              onEnter: () => {
                gsap.to(fadeInItem, {
                  y: 0,
                  opacity: 1,
                  visibility: "visible",
                  duration: ".8",
                  ease: "power1.inOut",
                  delay: index * 0.2,
                  onComplete: () => {
                    // fadeInアニメーションが終了した後にOdometerを開始
                    if (fadeInItem.querySelector("#odometer")) {
                      startOdometerAnimation();
                      graphAni();
                    }

                    if (fadeInItem.querySelector(".js-odometer")) {
                      const countValue = fadeInItem
                        .querySelector(".js-odometer")
                        .getAttribute("data-count");

                      fadeInItem.querySelector(".js-odometer").innerHTML =
                        countValue;
                    }
                  },
                });
              },
              once: true,
              // markers: true,
            });
          });
        }
      });
    } else {
      sections.forEach((section) => {
        const fadeInItems = section.querySelectorAll(".js-fade-in");

        if (fadeInItems.length > 0) {
          fadeInItems.forEach((fadeInItem, index) => {
            gsap.set(fadeInItem, { opacity: 0, visibility: "hidden", y: 100 }); // 初期状態を設定
            ScrollTrigger.create({
              trigger: section,
              start: "top 70%",
              onEnter: () => {
                gsap.to(fadeInItem, {
                  y: 0,
                  opacity: 1,
                  visibility: "visible",
                  duration: ".8",
                  ease: "power1.inOut",
                  delay: index * 0.2,
                });
              },
              once: true,
              // markers: true,
            });
          });
        }
      });
    }
  }, 2000);
}
